import { EDIT_FEEDBACK, FETCH_FEEDBACK, DESTROY_FEEDBACK } from "../actionTypes";

const fetchNews = (state = [], action) => {
    switch (action.type) {
        case FETCH_FEEDBACK:
            state = [];
            return [...state, ...action.feedbacks];
        
        case EDIT_FEEDBACK:
            return state.map(feedback => {
                if (feedback.id === action.feedback.id) {
                    return {
                        ...feedback,
                        ...action.feedback
                    };
                }

                return feedback;
            });
        
            case DESTROY_FEEDBACK:
                return state[action.key] = [];
        
        default:
            return state;
    }
};

export default fetchNews;